export enum StorageItems {
  'USER' = 'user',
  'PROFILES' = 'profiles',
  'SELECTED_INDEX' = 'selectedProfileIndex',
  'REMEMBER_ME' = 'isRememberMe',
  'LANGUAGE' = 'lang',
  'PROFILE' = 'profile',
  'QUEST' = 'questionnaire',
  'USERID' = 'userId',
  'USERNAME' = 'username',
  'RESPONSEID' = 'responseId',
  'PARTICIPANTID' = 'participantId',
  'ANONYMUSER' = 'anonymUser',
  'GOOGLE_ACCESS_TOKEN' = 'googleAccessToken',
  'GOOGLE_ID_TOKEN' = 'googleIdToken',
  'USER_ID_FOR_ADMIN' = 'userIdForAdmin',
  'LAST_SELECTED_SUBJECT' = 'lastSelectedSubject'
}
